<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="showForm">
    <cnc-comments [commentType]="commentType"></cnc-comments>
  </div>
</div>
